import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import { DownloadOutlined } from '@ant-design/icons';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  withStyles,
  TableContainer,
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from "../../utils/index";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  bordercolors: {
    border: "1px solid #eee5e5",
    background: "blue",
  },
  table: {
    minWidth: 700,
  },
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  customTableContainer: {
    overflowX: "initial",
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginpivotRight: theme.spacing(1),
    width: 200,
  },
  table: {
    width: "fit-content",
  },
  csv: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  report: {
    marginBottom: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  leadSearchButton: {
    backgroundColor: "#FDB913",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  leadClearButton: {
    backgroundColor: "#f7b7b7", // light red background
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#1C375D",
    color: '#FFF2EB',
    fontWeight: "500",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const ReminderDashboard = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [store, setStore] = useState([]);
  const [commonExpCenter, setExpCenter] = useState([]);
  const [storeDateFilter, setPivotDatefilters] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [showDetailedModal, setShowDetailedModal] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const csvButtonRef = useRef(null);
  const [popMonthData, setPopMonthData] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectLost, setSeletLost] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [selectedSearchType, setSelectedSearchType] = useState("");
  const searchTypes = [
    "Customer Name",
    "Email ID",
    "Lead No",
    "Project No",
    "Contact No",
    "Unique Lead No",
  ];
  const [reminderTableCsvData, setReminderTableCsvData] = useState([]);
  const reminderTableCsvButtonRef = useRef(null);
  const [triggerDownload, setTriggerDownload] = useState(false);


const [pivot, setPivot] = useState('');

  useEffect(() => {
    expCenters();
    checkPivot('reminderNotClose')
    setSelectedRole('ALL')
  }, []);

  const headers = [
    { key: "serialNo", label: "Sl. No." },
    { key: "projectCode", label: "Project No." },
    { key: "leadNumber", label: "Lead No." },
    { key: "clientName", label: "Client Name" },
    { key: "expCtrName", label: "Exp. Ctr Name" },
    { key: "currentStage", label: "Current Stage" },
    { key: "department", label: "Department" },
    { key: "reminderDate", label: "Reminder Date" },
    { key: "leadCreatedDate", label: "Lead Created Date" },
    { key: "salesExecutive", label: "Sales Executive" },
    { key: "asm", label: "ASM" },
  ];

  // Trigger download when data is ready
  useEffect(() => {
    if (triggerDownload && reminderTableCsvData.length > 0) {
      const timer = setTimeout(() => {
        if (reminderTableCsvButtonRef.current?.link) {
          try {
            reminderTableCsvButtonRef.current.link.click();
          } catch (error) {
            console.error("Error triggering CSV download:", error);
            props?.setSnackInfo("Error downloading CSV", "error");
          }
          setTriggerDownload(false);
        } else {
          // Retry if link is not ready
          setTimeout(() => {
            if (reminderTableCsvButtonRef.current?.link) {
              reminderTableCsvButtonRef.current.link.click();
              setTriggerDownload(false);
            }
          }, 200);
        }
      }, 300);
      
      return () => clearTimeout(timer);
    }
  }, [triggerDownload, reminderTableCsvData]);

  const csvDownloadHandler = async (data) => {
    setLoading(true);
    try {
      let csvArray = [];
      for (let i = 0; i < popMonthData.length; i++) {
        let obj = {
            serialNo: i + 1,
            projectCode: popMonthData[i]?.erpProjectNo || "N/A",
            leadNumber: popMonthData[i]?.lead_no || "N/A",
            clientName: popMonthData[i]?.customerId?.name || "N/A", // Corrected the optional chaining
            expCtrName: popMonthData[i]?.experienceCenterId?.name || "N/A",
            currentStage: popMonthData[i]?.currentStage || "NA",
            department: popMonthData[i]?.departmentId?.name || "NA",
            reminderDate: moment(popMonthData[i]?.reminderData?.reminderDate).format('DD-MM-YYYY') || "NA",
            leadCreatedDate: moment(popMonthData[i]?.createdAt).format('DD-MM-YYYY') || "NA",
            salesExecutive: popMonthData[i]?.salesUser?.name || "NA",
            asm: popMonthData[i]?.salesAssistantManager?.name || "NA",
          };
          
        csvArray.push(obj);
        // obj = {
        //   serialNo: "",
        //   projectCode: "",
        //   clientName: "",
        //   totalValue: "",
        //   expCtrName: "",
        //   salesWonDate: "",
        //   internalDesignSignOffDate: "",
        //   designSignOffDate: "",
        //   materialDeliveryDate: "",
        //   actualCompletionDate: "",
        //   HoldRevocationDate: "",
        //   reminderDate: "",
        //   leadCreatedDate: "",
        //   salesExecutive: "",
        //   asm: ""
        // };
        // csvArray.push(obj);
      }
      setCsvData(csvArray);
      downloadExcel();
    } catch (error) {
      console.log("error", error);
      props?.setSnackInfo(
        error?.response?.data?.message ?? "Something went wrong",
        "error"
      );
    }
    setLoading(false);
  };

  const downloadExcel = () => {
    setLoading(true);
    try {
      setTimeout(() => {
        csvButtonRef.current.link.click();
      });
    } catch (err) {
      console.error(err.message);
    }
    setLoading(false);
  };

  const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
  let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));

  const expCenterData = {};
  store.forEach((el) => {
      if (!expCenterData[el.experienceCenterName]) {
          expCenterData[el.experienceCenterName] = [];
      }
      expCenterData[el.experienceCenterName].push(el);
  });

  const expCenters = async () => {
    props.setLoading(true);
    try {
      let response = await HttpService.getExpericenCenters();
      const matchedUsers = response.data.filter((user) => {
        return userDetails.experienceCenterId.includes(user._id);
      });
      setExpCenter(matchedUsers);
    } catch (error) {
      console.error("Error fetching experience centers:", error);
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  const reminderNotCloseData = async (addExpCenter, usersData, selectedSearchType, searchInput) => {
    let expCenterData = addExpCenter?.map((el) => el._id);
    let users = "";
    if ((usersData?.users && usersData?.users.length !== 0) ||(selectedUsers && selectedUsers.length !== 0)) {
      users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id);
    }
    let obj = {
      startDate: storeDateFilter.startDate,
      endDate: storeDateFilter.endDate,
      selectedExperienceCenter: expCenterData ? expCenterData : "",
      tokenPercentage: selectedValue !== "" ? selectedValue : "",
      users: users ? users : "",
      userExpCenter: userDetails.experienceCenterId,
      lost: selectLost !== "" ? selectLost : "",
      pivotValue: "reminderNotClose",
      searchType: selectedSearchType ? selectedSearchType : "",
      search: searchInput ? searchInput.toUpperCase() : "",
      selectedRole: 'ALL'
    };
    props.setLoading(true);
    try {
      let response = await HttpService.getReminderNotCloseDataBasedOnExpCenter(obj);
      setStore(response.data);
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  const checkPivot = async (value) => {
    setPivot(value)
     if (value === 'reminderNotClose') {
        reminderNotCloseData();
        setSelectedExperienceCenter([]);
        setSelectedUsers([]);
        setSelectedRole("ALL")
        setSearchInput("")
        setSelectedSearchType("")
    } 
}

  const handleSearchType = (value) => {
    setSelectedSearchType(value);
    setSearchInput("");
  };

  const handleSearch = async (value) => {
    reminderNotCloseData(
      selectedExperienceCenter,
      selectedUsers,
      selectedSearchType,
      searchInput
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && selectedSearchType && searchInput) {
      handleSearch(searchInput.toUpperCase());
    }
  };

  const clearDateFilter = () => {
    setSearchInput("");
    setSelectedSearchType("");
    reminderNotCloseData(selectedExperienceCenter, selectedUsers, "", "");
  };

  const getDataBasedOnClick = async (e, innerEl, status) => {
    let expCenterData = selectedExperienceCenter?.map((el) => el._id)
    let users = ''
    if (selectedUsers && selectedUsers.length !== 0) {
        users = selectedUsers?.map((el) => el._id)
    }
    let obj = {
        startDate: storeDateFilter.startDate,
        endDate: storeDateFilter.endDate,
        status: status,
        selectedExperienceCenter: innerEl.experienceCenterId ? innerEl.experienceCenterId : expCenterData,
        userExpCenter: userDetails.experienceCenterId,
        pivotValue: "reminderNotClose",
        tokenPercentage: selectedValue !== "" ? selectedValue : "",
        users: users ? users : "",
        searchType: selectedSearchType ? selectedSearchType : "",
        search: searchInput !== "" ? searchInput.toUpperCase() : ""
    }
    props.setLoading(true);
    obj.role = selectedRole
    try {
        let response = await HttpService.getDataBasedClickReminderNotClose(obj);
        setPopMonthData(response.data)
        setShowDetailedModal(true)
    } catch (error) {
        props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    }
    props.setLoading(false);
}
  
  return (
    <div className="App">
      {/* first table */}
      <div>
        <div>
          <Paper className={classes.paper}>
          <Grid
              container
              spacing={1}
              justifyContent="center"
              alignItems="center"
            >
          </Grid>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "30px",
              }}
            >
              {/* Search Type Dropdown */}
              <TextField
                select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedSearchType}
                label="Search Type"
                name="searchType"
                onChange={(e) => handleSearchType(e.target.value)}
                variant="outlined"
                style={{ width: "30%", marginRight: "2%" }}
                size="small"
              >
                {searchTypes &&
                  searchTypes?.map((el, index) => (
                    <MenuItem key={index} value={el}>
                      {el}
                    </MenuItem>
                  ))}
              </TextField>

              {/* Search Input */}
              <TextField
                label="Enter the input"
                name="searched"
                size="small"
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                }}
                onKeyDown={handleKeyDown} // Listening for the "Enter" key press
                variant="outlined"
                style={{ width: "80%" }}
              />

              {/* Search Button */}
              <Button
                disabled={!selectedSearchType || !searchInput}
                variant="contained"
                color="primary"
                size="medium"
                style={{ alignSelf: "center", marginLeft: 20 }}
                className={classes.leadSearchButton}
                onClick={() => handleSearch(searchInput.toUpperCase())}
              >
                Search
              </Button>

              {/* Clear Filter Button */}
              <Button
                variant="contained"
                color="secondary"
                size="medium"
                style={{ marginLeft: 10 }}
                className={classes.leadClearButton}
                onClick={clearDateFilter}
              >
                Clear Filter
              </Button>
            </div>
          </Paper>
        </div>
        <br />
        <div>
        <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid item xs={2}>
              <CSVLink
                data={reminderTableCsvData}
                filename={`Reminder_Dashboard_${moment().format('YYYY-MM-DD')}.csv`}
                ref={reminderTableCsvButtonRef}
                style={{ textDecoration: 'none', display: 'none' }}
              />
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                style={{
                  backgroundColor: "#355025",
                  color: "#FFF2EB",
                  padding: "0.4rem 2rem",
                  border: "none",
                  marginBottom: '10px',
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  
                  // Generate CSV data synchronously
                  const csvData = (() => {
                    try {
                      if (!store || store.length === 0) {
                        return [];
                      }

                      // Use the EXACT same data structures as the table uses
                      const localExpCenterData = {};
                      store.forEach((el) => {
                        if (!localExpCenterData[el.experienceCenterName]) {
                          localExpCenterData[el.experienceCenterName] = [];
                        }
                        localExpCenterData[el.experienceCenterName].push(el);
                      });

                      const localUniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));
                      const localUniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));

                      if (localUniqueexperienceCenterNames.length === 0) {
                        return [];
                      }

                      const csvRows = [];


                      const headerRow = {
                        "Particulars": ""
                      };

                      const headerColumns = [];
                      localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        if (localExpCenterData[experienceCenterName]) {
                          localExpCenterData[experienceCenterName].forEach((innerEl) => {
                            // Only add if expCenterCode exists (same as table would show)
                            if (innerEl.expCenterCode) {
                              headerColumns.push(innerEl.expCenterCode);
                            }
                          });
                        }
                      });
                      
                      headerColumns.forEach((expCenterCode) => {
                        if (expCenterCode) {
                          headerRow[expCenterCode] = "";
                        }
                      });
                      headerRow["Grand Total"] = "";
                      csvRows.push(headerRow);

                      // Row 1: Due Reminder
                      const row1 = {
                        "Particulars": "Due Reminder"
                      };

                      localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        if (localExpCenterData[experienceCenterName]) {
                          localExpCenterData[experienceCenterName].forEach((innerEl) => {
                            if (innerEl.expCenterCode) {
                              // If this expCenterCode already exists, sum the values (matching table aggregation)
                              if (row1[innerEl.expCenterCode] !== undefined) {
                                row1[innerEl.expCenterCode] += (innerEl.dueCount || 0);
                              } else {
                                row1[innerEl.expCenterCode] = innerEl.dueCount || 0;
                              }
                            }
                          });
                        }
                      });

                      // Grand Total - sum of all displayed cells (the values actually shown in CSV row)
                      const row1GrandTotal = Object.keys(row1).reduce((sum, key) => {
                        return (key !== "Particulars" && key !== "Grand Total") ? sum + (parseFloat(row1[key]) || 0) : sum;
                      }, 0);
                      row1["Grand Total"] = row1GrandTotal;
                      csvRows.push(row1);

                      // Row 2: Completed Reminder
                      const row2 = {
                        "Particulars": "Completed Reminder"
                      };

                      localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        if (localExpCenterData[experienceCenterName]) {
                          localExpCenterData[experienceCenterName].forEach((innerEl) => {
                            if (innerEl.expCenterCode) {
                              // If this expCenterCode already exists, sum the values (matching table aggregation)
                              if (row2[innerEl.expCenterCode] !== undefined) {
                                row2[innerEl.expCenterCode] += (innerEl.completedCount || 0);
                              } else {
                                row2[innerEl.expCenterCode] = innerEl.completedCount || 0;
                              }
                            }
                          });
                        }
                      });

                      // Grand Total - sum of all displayed cells (the values actually shown in CSV row)
                      const row2GrandTotal = Object.keys(row2).reduce((sum, key) => {
                        return (key !== "Particulars" && key !== "Grand Total") ? sum + (parseFloat(row2[key]) || 0) : sum;
                      }, 0);
                      row2["Grand Total"] = row2GrandTotal;
                      csvRows.push(row2);

                      return csvRows;
                    } catch (error) {
                      console.error("Error generating reminder table CSV:", error);
                      return [];
                    }
                  })();

                  // Set the data and trigger download
                  if (csvData.length > 0) {
                    setReminderTableCsvData(csvData);
                    // Use a longer timeout to ensure state is updated
                    setTimeout(() => {
                      setTriggerDownload(true);
                    }, 100);
                  } else {
                    props?.setSnackInfo("No data available to export", "warning");
                  }
                }}
              >
                Download CSV
              </Button>
            </Grid>
          </Grid>
        {/* {userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.SalesUser) && */}
          <div style={{ maxHeight: "500px", overflow: "auto" }}>
            <TableContainer
              component={Paper}
              classes={{ root: classes.customTableContainer }}
              style={{ marginTop: "10px" }}
            >
              <Table style={{ minWidth: "500px" }}>
                <TableHead style={{ position: "sticky", top: 0, background: "white" }}>
                  <>
                  <StyledTableRow>
                  <StyledTableCell
                      className={classes.bordercolors}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 9,
                        textAlign: "center",
                        text:'white'
                      }}
                    >
                    </StyledTableCell>
                   {store.slice(0, uniqueexperienceCenterCode.length - 1).map((experienceCenterName, index) => (
                        <StyledTableCell className={classes.bordercolors} key={index}
                          style={{
                            fontSize: index === uniqueexperienceCenterNames.length - 1 ? '15px' : '13px',
                            fontWeight: 'bolder',
                            textAlign: 'center',
                            position: 'sticky',
                            top: 0,
                            zIndex: 1,
                            color: 'white'
                          }}>
                          <Tooltip title={`${experienceCenterName.experienceCenterName}-${experienceCenterName.expCtrCityName}`} placement="top">
                            <span style={{ cursor: "pointer" }}>
                              {experienceCenterName.expCenterCode}
                            </span>
                          </Tooltip>
                        </StyledTableCell>
                      ))}
                      <StyledTableCell style={{ color: 'white',  fontSize:'13px', fontWeight: 'bolder', textAlign: 'center',}}> Grand Total </StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                      <StyledTableCell
                      className={classes.bordercolors}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 9,
                        textAlign: "center",
                        text:'white'
                      }}
                    > Due Reminder
                    </StyledTableCell>
                        {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                          <>
                          {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                            <StyledTableCell
                              className={classes.bordercolors}
                              key={dataIndex}
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                top: 0,
                                textDecoration:'underline',
                                background: "white",
                                fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                              }}
                              onClick={(e) => getDataBasedOnClick(e, innerEl, 'dueCount')}
                            >
                             { innerEl?.dueCount } 
                            </StyledTableCell>
                          ))}
                        </>
                      ))} 
                 </StyledTableRow>
                 <StyledTableRow>
                      <StyledTableCell
                      className={classes.bordercolors}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 9,
                        textAlign: "center",
                        text:'white'
                      }}
                    > Completed Reminder
                    </StyledTableCell>
                        {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                          <>
                          {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                            <StyledTableCell
                              className={classes.bordercolors}
                              key={dataIndex}
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                top: 0,
                                textDecoration:'underline',
                                background: "white",
                                fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                              }}
                              onClick={(e) => getDataBasedOnClick(e, innerEl, 'completedCount')}
                            >
                             { innerEl?.completedCount } 
                            </StyledTableCell>
                          ))}
                        </>
                      ))} 
                 </StyledTableRow>
                 </>
                </TableHead>
              </Table>
            </TableContainer>
          </div>
        {/* } */}
        </div>
      </div>
     
      <Modal
        title="Reminder Dashboard"
        centered
        visible={showDetailedModal}
        onCancel={() => setShowDetailedModal(false)}
        width={1000}
        maskClosable={true}
        footer={null}
      >
        <div className={classes.csv}>
          <CSVLink
            headers={headers}
            filename={`reminderData.csv`}
            data={csvData}
            ref={csvButtonRef}
          />
          <Button
            onClick={() => csvDownloadHandler(popMonthData)}
            style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
            variant="contained"
            color="secondary"
          >
            Download CSV
          </Button>
        </div>
        {popMonthData && (
          <TableContainer component={Paper} className={classes.table}>
            <Table
              style={{ width: 450 }}
              className={classes.table}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Sl. No.</StyledTableCell>
                  <StyledTableCell>Project No.</StyledTableCell>
                  <StyledTableCell>Lead No.</StyledTableCell>
                  <StyledTableCell>Client Name</StyledTableCell>
                  <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                  <StyledTableCell>Current Stage</StyledTableCell>
                  <StyledTableCell>Department</StyledTableCell>
                  <StyledTableCell>Reminder Date</StyledTableCell>
                  <StyledTableCell>Lead Created Date</StyledTableCell>
                  <StyledTableCell>Sales Executive</StyledTableCell>
                  <StyledTableCell>ASM</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {popMonthData &&
                  popMonthData.map((data, i) => {
                    return (
                      <>
                        <StyledTableRow key={i}>
                          <StyledTableCell>{i + 1}</StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.erpProjectNo ? (
                              <Link
                                to={`/project-logs/${data?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {data?.erpProjectNo}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.lead_no ? (
                              <Link
                                to={`/project-logs/${data?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {data?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.customerId?.name}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.experienceCenterId?.name}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.currentStage}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.departmentId?.name}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                           { moment(data?.reminderData?.reminderDate).format('DD-MM-YYYY')}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                           { moment(data?.createdAt).format('DD-MM-YYYY')}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.salesUser ? data?.salesUser?.name : 'NA'}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.salesAssistantManager ? data?.salesAssistantManager?.name : 'NA'}
                          </StyledTableCell>
                        </StyledTableRow>
                      </>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Modal>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(ReminderDashboard);




